import "./switchBtns.scss"

const SwitchBtns = ({
  labelLeft,
  labelRight,
  onClickLeft,
  onClickRight,
  leftActive,
  disable = false,
}: $TSMigrationFixMe) => (
  <div className='wrap-switch-btns'>
    <button
      className={`switch-btn ${leftActive ? "switch-btn-active" : ""}`}
      type='button'
      onClick={onClickLeft}
      disabled={disable}
    >
      {labelLeft}
    </button>

    <button
      className={`switch-btn ${!leftActive ? "switch-btn-active" : ""}`}
      type='button'
      onClick={onClickRight}
      disabled={disable}
    >
      {labelRight}
    </button>
  </div>
)

export default SwitchBtns
